module.exports = {"name":"jwplayer7","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-01-16","repo":"https://bitbucket.org/npaw/jwplayer7-adapter-js","libVersion":"6.1.9","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getThroughput","getRendition","getTitle","getIsLive","getResource","getPosition"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"],"filename":"native.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 15
// module chunks = 0